export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            爆料投稿
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mb-8 leading-relaxed">
            你有独家爆料？欢迎向我们投稿！我们严格保护投稿人隐私，匿名爆料同样欢迎。编辑团队会在24小时内审核回复，优质爆料一经采纳将署名发布并获得稿酬奖励。发送邮件至 <strong className="text-primary-600">tips@heiliaodaily.com</strong> 或填写下方表单，一起吃更大的瓜！
          </p>

          <div className="bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/60">
            <form className="flex flex-col gap-4 text-left" data-readdy-form="true">
              <div className="antispam-field">
                <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">你的昵称</label>
                  <input
                    type="text"
                    name="nickname"
                    placeholder="可选，匿名投稿可留空"
                    className="w-full px-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">联系邮箱</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="your@email.com"
                    className="w-full px-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground-700 mb-1.5">爆料标题</label>
                <input
                  type="text"
                  name="title"
                  placeholder="简要描述你要爆料的内容"
                  className="w-full px-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground-700 mb-1.5">详细内容</label>
                <textarea
                  name="content"
                  rows={5}
                  maxLength={500}
                  placeholder="请详细描述你的爆料内容，越详细越好（最多500字）"
                  className="w-full px-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                ></textarea>
                <p className="text-xs text-foreground-400 mt-1">最多500字</p>
              </div>
              <button
                type="submit"
                className="w-full sm:w-auto self-center px-8 py-3 bg-primary-500 text-background-50 rounded-full font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line mr-2"></i>提交爆料
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}